import { FolkHyperedge } from '../folk-hyperedge';
FolkHyperedge.define();
export { FolkHyperedge };
//# sourceMappingURL=folk-hyperedge.js.map